import { h } from 'preact';
import { update } from 'Emitter';
import { UI } from 'StateEvents';
import BaseComponent from '../BaseComponent';
import './PlayPause.css';

export default class PlayPause extends BaseComponent {
  onClick() {
    update(UI.PLAYED, 'onClick', true);
  }

  render(props) {
    if(props.paused) {
      return (
        <div onClick={ this.onClick } class="playPauseContainer">
          <div class="playArrow clickable"></div>
        </div>
      )
    }

    return null;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/PlayPause/PlayPause.js